import { OpenFeature } from '@openfeature/web-sdk';
import { OpenFeatureProvider } from '@openfeature/react-sdk';
import posthog from 'posthog-js';
import { type ReactNode, useMemo } from 'react';
import useBackend, { type BackendContextType } from '@contexts/useBackend/useBackend';
import {
  ProvideFeatureFlags as SharedProvideFeatureFlags,
  createPosthogTelemetrySink,
  type ProvideFeatureFlagsProps
} from '@bett3r-dev/teselly-feature-flags';

// The OpenFeature SDK + this app are typed against React 18; the package resolves
// React 19's @types/react. The two `ComponentType`/`ReactNode` shapes differ
// nominally only — this cast is isolated to the single injection point.
// See the TV1-1697 SDD risk table.
const OpenFeatureProviderShim =
  OpenFeatureProvider as unknown as ProvideFeatureFlagsProps['OpenFeatureProvider'];

export const ProvideFeatureFlags = ({ children }: { children: ReactNode }) => {
  const { backend } = useBackend() as BackendContextType;
  const telemetry = useMemo(() => createPosthogTelemetrySink( posthog ), []);
  return (
    <SharedProvideFeatureFlags
      backend={backend}
      telemetry={telemetry}
      openFeature={OpenFeature}
      OpenFeatureProvider={OpenFeatureProviderShim}
    >
      {children}
    </SharedProvideFeatureFlags>
  );
};

export { useFeatureFlagProvider } from '@bett3r-dev/teselly-feature-flags';
